import _Button from "@material-ui/core/esm/Button";
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { getSupplierInStockQuantityBySize, getStockQuantityToShow } from 'swag-client-common/utils/product.utils';
import OutOfStockMessage from 'swag-client-common/components/ui/out-of-stock-message';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import detailsClasses from '../details/details.scss';
import { singleQuantityBlockSelector } from '../../../../../redux/related-product-builder-popup/related-product.selectors';
import { singleQuantityBlockDispatcher } from '../../../../../redux/related-product-builder-popup/related-product.dispatchers';
import styles from './quantity-block-single-styles';
const QuantityBlockSingleComponent = ({
  number,
  totalQuantity,
  showPriceBreaks,
  minQuant,
  quantities,
  size,
  variantIndex,
  quantityPerSizeEnabled,
  errorText,
  onPriceBreakClick,
  onSingleQuantityChange,
  onGeneralQuantityChange,
  classes,
  stockLevelsByVariantSku,
  variant,
  productIsAlwaysInStock,
  outOfStockThreshold
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(detailsClasses.block)
}, /*#__PURE__*/React.createElement("h5", {
  className: detailsClasses.blockTitle
}, /*#__PURE__*/React.createElement("span", {
  className: detailsClasses.number
}, number), "I would like", ' ', /*#__PURE__*/React.createElement(HiddenLabel, {
  htmlFor: "relatedProductQuantity",
  label: "Quantity for related product:"
}), /*#__PURE__*/React.createElement("input", {
  id: "relatedProductQuantity",
  className: classnames(detailsClasses.pink, detailsClasses.inputSize, {
    [detailsClasses.inputError]: totalQuantity < minQuant
  }),
  type: "number",
  min: "1",
  value: totalQuantity,
  onChange: e => onGeneralQuantityChange(e.target.value)
}), ' ', "printed"), showPriceBreaks && /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.buttonContainerRight
}, /*#__PURE__*/React.createElement(_Button, {
  onClick: onPriceBreakClick,
  variant: "contained",
  className: classes.button
}, "Price Breaks")), /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.errorMessage
}, !!errorText && errorText), quantityPerSizeEnabled && /*#__PURE__*/React.createElement("div", {
  className: detailsClasses.sizesContainer
}, quantities && size.options && size.options.map((sizeName, i) => {
  var _variant$sizeSkus;
  const supplierInStockQuantity = getSupplierInStockQuantityBySize({
    isAlwaysInStock: productIsAlwaysInStock || (variant === null || variant === void 0 ? void 0 : variant.isAlwaysInStockVariant),
    variantSizeSkus: (_variant$sizeSkus = variant === null || variant === void 0 ? void 0 : variant.sizeSkus) !== null && _variant$sizeSkus !== void 0 ? _variant$sizeSkus : {},
    currentSizeName: sizeName,
    stockLevelsByVariantSku
  });
  const isOutOfStock = supplierInStockQuantity <= outOfStockThreshold;
  const value = quantities[i] || 0;
  const grayedOut = isOutOfStock && value === 0;
  const inputId = `relatedProductQuantityForSize${sizeName}`;
  return /*#__PURE__*/React.createElement("div", {
    key: i,
    className: detailsClasses.sizeItem
  }, /*#__PURE__*/React.createElement("span", {
    className: detailsClasses.input
  }, /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: inputId,
    label: `Quantity for related product ${sizeName} size:`
  }), /*#__PURE__*/React.createElement("input", {
    id: inputId,
    className: classnames(detailsClasses.pink, {
      [detailsClasses.grayedOut]: grayedOut
    }),
    disabled: grayedOut,
    type: "number",
    min: "0",
    value: value,
    onChange: e => onSingleQuantityChange(e.target.value, variantIndex, i)
  })), /*#__PURE__*/React.createElement("span", {
    className: detailsClasses.label
  }, sizeName), /*#__PURE__*/React.createElement(OutOfStockMessage, {
    twoLines: true,
    showCompletelyOutOfStockMessage: true,
    inStockQuantity: getStockQuantityToShow({
      isOutOfStock,
      availableQuantity: supplierInStockQuantity,
      currentQuantity: value
    })
  }));
})));
export const QuantityBlockSingle = connect(singleQuantityBlockSelector, singleQuantityBlockDispatcher)(withStyles(styles)(QuantityBlockSingleComponent));